import faker from 'faker'
import { useEffect } from 'react'
import Home from './modules/Home'
import { ROLES } from './config/user'
import Profile from './modules/Profile'
import Login from './modules/Auth/Login'
import Loading from './components/Loading'
import { AxiosToken } from './config/axios'
import DocEngine from './modules/DocEngine'
import Documents from './modules/Documents'
import NotFound from './components/NotFound'
import Register from './modules/Auth/Register'
import Payment from './modules/Payment/Payment'
import PrivateRoute from './components/PrivateRoute'
import { useSession } from './context/SessionContext'
import Search from './modules/DocEngine/SuperUserPanel/Search'
import RecoveryPassword from './modules/Auth/RecoveryPassword'
import { SessionContextProvider } from './context/SessionContext'
import Share from './modules/DocEngine/SharePanel/ShareDocumentsList'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { default as TemplateListTypes } from './modules/DocEngine/TemplateListTypes'
import { default as UserEditor } from './modules/DocEngine/UserPanel/TemplateEditor'
import { default as AdminEditor } from './modules/DocEngine/AdminPanel/TemplateEditor'
import { default as TemplateEditorShare } from './modules/DocEngine/SharePanel/TemplateEditor'
import { default as SuperUserEditor } from './modules/DocEngine/SuperUserPanel/TemplateEditor'
import { default as BussinessUserEditor } from './modules/DocEngine/BussinessPanel/TemplateEditor'
import { default as TemplateListDocumentsType } from './modules/DocEngine/TemplateListDocumentsType'
import { default as TemplateListBussiness } from './modules/DocEngine/BussinessPanel/TemplateList'

const token = localStorage.getItem('token')
if (token) {
  AxiosToken(token)
}
faker.locale = 'es_MX'

const RouterByRole = () => {
  const { user, getUserData, autenticated, token } = useSession()

  useEffect(() => {
    if (getUserData && token) getUserData()
  }, [])

  if (!user && token) {
    return <Loading text={'CARGANDO ...'} />
  }

  /**
   * This component is to define the app routes
  */
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/recover-password" component={RecoveryPassword} />
        {/* <PrivateRoute exact path="/docengine" component={DocEngine} /> */}
        <Route
          exact
          path="/docengine"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
                {user?.role === ROLES.ADMIN && (
                  <PrivateRoute
                    exact
                    path="/docengine"
                    component={DocEngine}
                  />
                )}
                {user?.role === ROLES.USER && (
                  <PrivateRoute
                    exact
                    path="/docengine"
                    component={TemplateListTypes}
                  />
                )}
                {user?.role === ROLES.SUPER_USER && (
                  <PrivateRoute
                    exact
                    path="/docengine"
                    component={TemplateListTypes}
                  />
                )}
                {user?.role === ROLES.BUSSINESS && (
                  <PrivateRoute
                    exact
                    path="/docengine"
                    component={TemplateListBussiness}
                  />
                )}
              </>
            )
          }
        />
        
        <Route
          exact
          path="/docengine/document-type/:name"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
                {user?.role === ROLES.USER && (
                  <PrivateRoute
                    exact
                    path="/docengine/document-type/:name"
                    component={TemplateListDocumentsType}
                  />
                )}
              </>
            )
          }
        />

        <Route
          exact
          path="/docengine/document-type"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
                {/* {user?.role === ROLES.USER && (
                  <PrivateRoute
                    exact
                    path="/docengine/document-type"
                    component={TemplateListDocumentsType}
                  />
                )} */}
                {user?.role === ROLES.SUPER_USER && (
                  <PrivateRoute
                    exact
                    path="/docengine/document-type"
                    component={TemplateListDocumentsType}
                  />
                )}
              </>
            )
          }
        />

        <Route
          exact
          path="/docengine/editor/:name"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
                {user?.role === ROLES.USER && (
                  <PrivateRoute
                    exact
                    path="/docengine/editor/:name"
                    component={UserEditor}
                  />
                )}
              </>
            )
          }
        />

        <Route
          exact
          path="/docengine/editor"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
                {user?.role === ROLES.ADMIN && (
                  <PrivateRoute
                    exact
                    path="/docengine/editor"
                    component={AdminEditor}
                  />
                )}
                {/* {user?.role === ROLES.USER && (
                  <PrivateRoute
                    exact
                    path="/docengine/editor/:name"
                    component={UserEditor}
                  />
                )} */}
                {user?.role === ROLES.SUPER_USER && (
                  <PrivateRoute
                    exact
                    path="/docengine/editor"
                    component={SuperUserEditor}
                  />
                )}
                {user?.role === ROLES.BUSSINESS && (
                  <PrivateRoute
                    exact
                    path="/docengine/editor"
                    component={BussinessUserEditor}
                  />
                )}
              </>
            )
          }
        />
        <Route
          exact
          path="/search"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
                {user?.role === ROLES.SUPER_USER && (
                  <PrivateRoute
                    exact
                    path="/search"
                    component={Search}
                  />
                )}
              </>
            )
          }
        />
        <Route
          exact
          path="/share-documents"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
              {user?.role === ROLES.USER && (
                  <PrivateRoute
                    exact
                    path="/share-documents"
                    component={Share}
                  />
                )}
                {user?.role === ROLES.SUPER_USER && (
                  <PrivateRoute
                    exact
                    path="/share-documents"
                    component={Share}
                  />
                )}
                {user?.role === ROLES.BUSSINESS && (
                  <PrivateRoute
                    exact
                    path="/share-documents"
                    component={Share}
                  />
                )}
              </>
            )
          }
        />
        <Route
          exact
          path="/share-document/:id"
          render={() =>
            !autenticated || !token || !user ? (
              <Redirect to="/login" />
            ) : (
              <>
                {user?.role === ROLES.USER && (
                  <PrivateRoute
                    exact
                    path="/share-document/:id"
                    component={TemplateEditorShare}
                  />
                )}
                {user?.role === ROLES.SUPER_USER && (
                  <PrivateRoute
                    exact
                    path="/share-document/:id"
                    component={TemplateEditorShare}
                  />
                )}
                {user?.role === ROLES.BUSSINESS && (
                  <PrivateRoute
                    exact
                    path="/share-document/:id"
                    component={TemplateEditorShare}
                  />
                )}
              </>
            )
          }
        />
        <PrivateRoute exact path="/documents" component={Documents} />
        <PrivateRoute exact path="/profile" component={Profile} />
        <PrivateRoute exact path="/payment" component={Payment} />   
        <Route component={NotFound} />
      </Switch>
    </Router>
  )
}

function App(): JSX.Element {
  return (
    <SessionContextProvider>
      <RouterByRole />
    </SessionContextProvider>
  )
}

export default App